module.exports = __webpack_public_path__ + "images/header-collaborate_1c414cda55dedff504490707fd4c66f8.jpg";